"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFgpPopState = void 0;
var FgpPopState_1 = require("@/pages/common/states/FgpPopState");
var FgpPopTranslate_init_1 = require("@/pages/common/states/FgpPopTranslate.init");
exports.defaultFgpPopState = {
    t: FgpPopTranslate_init_1.defaultFgpPopTranslate,
    size: FgpPopState_1.FgpPopType.WITH_PHOTO,
    isActive: false,
    image: '/res/img/fgp-popup-property.jpg',
};
